import { privateApi } from "services/api/private";

export const setOrganizationOnboardingCompleted = async () => {
  await privateApi.post("/setOrganizationWelcomeCompleted");
};
